export default __webpack_public_path__ + "static/media/boards.748b0692.svg";